import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=155ecb03&scoped=true&"
import script from "./ContentLayout.vue?vue&type=script&lang=ts&"
export * from "./ContentLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=155ecb03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ecb03",
  null
  
)

export default component.exports